<template>
  <mt-tabbar v-model="active" fixed>
    <mt-tab-item id="home">
      <img
        slot="icon"
        src="../assets/img/home_active.png"
        v-show="active == 'home'"
      />
      <img slot="icon" src="../assets/img/home.png" v-show="active != 'home'" />
      首页
    </mt-tab-item>
    <mt-tab-item id="live">
      <img
        slot="icon"
        src="../assets/img/trends_active.png"
        v-show="active == 'live'"
      />
      <img
        slot="icon"
        src="../assets/img/trends.png"
        v-show="active != 'live'"
      />
      直播
    </mt-tab-item>
    <mt-tab-item id="user">
      <img
        slot="icon"
        src="../assets/img/user_active.png"
        v-show="active == 'user'"
      />
      <img slot="icon" src="../assets/img/user.png" v-show="active != 'user'" />
      个人中心
    </mt-tab-item>
  </mt-tabbar>
</template>

<script>
export default {
  props: ['selected'],
  data() {
    return {
      active: this.selected,
      loginType: true
    }
  },
  watch: {
    active: {
      handler: function(newVal) {
        switch (newVal) {
          case 'home':
            // eslint-disable-next-line no-case-declarations
            const routeData = this.$router.resolve({
              path: '/'
            })
            window.open(routeData.href, '_blank')
            break
          case 'live':
            // eslint-disable-next-line no-case-declarations
            const routeData1 = this.$router.resolve({
              path: '/live'
            })
            window.open(routeData1.href, '_blank')
            break
          case 'user':
            // eslint-disable-next-line no-case-declarations
            const routeUser = this.$router.resolve({
              path: '/personal'
            })
            window.open(routeUser.href, '_blank')
            break
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.mint-tab-item {
  color: rgb(44, 62, 80);
  background-color: #fff;
  border-top: 1px solid #eee;
}
</style>
